import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/header.tsx");
